import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogPopup,
  DialogTitle,
  Field,
  FieldLabel,
  Input,
} from "@salestrak/ui";

interface IssueTypeCreateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (data: { name: string; description: string }) => Promise<void>;
}

export function IssueTypeCreateDialog({
  open,
  onOpenChange,
  onSubmit,
}: IssueTypeCreateDialogProps) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [submitting, setSubmitting] = useState(false);

  function handleOpenChange(next: boolean) {
    if (!next) {
      setName("");
      setDescription("");
    }
    onOpenChange(next);
  }

  async function handleCreate() {
    if (!name.trim()) return;
    setSubmitting(true);
    try {
      await onSubmit({ name: name.trim(), description: description.trim() });
      handleOpenChange(false);
    } finally {
      setSubmitting(false);
    }
  }

  // One Dialog serves both breakpoints, and Enter submits the form.
  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogPopup>
        <DialogHeader>
          <DialogTitle>Create project type</DialogTitle>
          <DialogDescription>
            Add a new project type to define the structure for your work items.
          </DialogDescription>
        </DialogHeader>
        <Box
          as="form"
          gap="md"
          paddingX="lg"
          onSubmit={(e) => {
            e.preventDefault();
            void handleCreate();
          }}
        >
          <Field>
            <FieldLabel>Name</FieldLabel>
            <Input
              placeholder="Type name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
            />
          </Field>
          <Field>
            <FieldLabel>Description</FieldLabel>
            <Input
              placeholder="Optional description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Field>
        </Box>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => handleOpenChange(false)}
            disabled={submitting}
          >
            Cancel
          </Button>
          <Button
            onClick={handleCreate}
            disabled={!name.trim()}
            loading={submitting}
          >
            Create
          </Button>
        </DialogFooter>
      </DialogPopup>
    </Dialog>
  );
}
